import { useCallback, useLayoutEffect, useRef, useState } from 'react';

/**
 * This hook returns the computed CSS Property and can e.g. be used to check if a certain "if-branch" is met
 * @param name Name of the property to check e.g. `--some-var`
 */
export const useCSSValue = name => {
  const [value, setValue] = useState();
  const ref = useRef(null);
  const getValue = useCallback(() => {
    if (!ref.current) {
      return;
    }
    const computedStyles = getComputedStyle(ref.current);
    return computedStyles.getPropertyValue(name);
  }, [name]);
  useLayoutEffect(() => {
    const updateValue = () => {
      setValue(getValue());
    };
    window.addEventListener('resize', updateValue);
    setTimeout(() => {
      updateValue();
    }, 1);
    return () => window.removeEventListener('resize', updateValue);
  }, [getValue]);
  return {
    value,
    ref
  };
};